var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import { omit } from 'lodash';
import { POSITION, TYPE } from 'vue-toastification';
function withDefaults(params) {
    const defaultNotificationParams = {
        message: '',
        type: 'info',
        position: POSITION.TOP_RIGHT,
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
    };
    return Object.assign(Object.assign({}, defaultNotificationParams), params);
}
function mapNotificationType(type) {
    const typeMap = {
        success: TYPE.SUCCESS,
        error: TYPE.ERROR,
        warning: TYPE.WARNING,
        info: TYPE.INFO,
    };
    return type ? typeMap[type] : undefined;
}
function mapToToastOptions(params) {
    return Object.assign(Object.assign({}, omit(params, ['message'])), { type: mapNotificationType(params.type) });
}
function createToast(params) {
    const options = mapToToastOptions(withDefaults(params));
    const showToast = (message_, options_) => {
        const message = message_ || 'No message was provided';
        const options = options_ || {};
        switch (params.type) {
            case 'success':
                return Vue.$toast.success(message, Object.assign(Object.assign({}, options), { type: TYPE.SUCCESS }));
            case 'error':
                return Vue.$toast.error(message, Object.assign(Object.assign({}, options), { type: TYPE.ERROR }));
            case 'warning':
                return Vue.$toast.warning(message, Object.assign(Object.assign({}, options), { type: TYPE.WARNING }));
            case 'info':
            default:
                return Vue.$toast.info(message, Object.assign(Object.assign({}, options), { type: TYPE.INFO }));
        }
    };
    const toastId = showToast(params.message, options);
    return {
        close() {
            Vue.$toast.dismiss(toastId);
        },
        update(newParams) {
            const updatedOptions = mapToToastOptions(withDefaults(newParams));
            Vue.$toast.update(toastId, Object.assign({ content: newParams.message || 'Error occured but no message was provided' }, updatedOptions));
        },
    };
}
function success(message, options) {
    return createToast(Object.assign({ message, type: 'success' }, options));
}
function error(message, options) {
    return createToast(Object.assign({ message, type: 'error' }, options));
}
function warning(message, options) {
    return createToast(Object.assign({ message, type: 'warning' }, options));
}
function info(message, options) {
    return createToast(Object.assign({ message, type: 'info' }, options));
}
function createAsyncToast(message, promise, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const toastRef = createToast(Object.assign({ message: `${message} in progress...` }, options));
        if (!toastRef) {
            console.error('Failed to create toast notification');
            return;
        }
        try {
            yield promise;
            toastRef.update({ message: `${message} succeeded!`, type: 'success' });
        }
        catch (_a) {
            toastRef.update({ message: `${message} failed!`, type: 'error' });
        }
    });
}
export { 
// single generic function
createToast, 
// specific functions
success, error, warning, info, 
// async version
createAsyncToast, };
